import React from 'react';
import _isEmpty from 'lodash.isempty';
import { Text } from '../../../../ui-kit';

function AddonViewV2(props) {
  const { addonType, addons } = props;

  const getAddonTitleByType = () => {
    switch (addonType) {
      case 'CAPTIONS':
        return 'Captions';
      case 'SOCIAL_ITERATIONS':
        return 'Social iterations';
      case 'VOICE_OVER_ARTISTS':
        return 'Voice over';
      default:return 'Others';
    }
  };

  // Render a single label / cost row.
  const renderAddonRow = (addon, idx) => {
    const { label, cost } = addon;
    return (
      <div
        className="addons-payment-v2__order-summary--content__details"
        key={`${label}-${idx}`}>
        <div className="addons-payment-v2__addon-item">{label}</div>
        <div className="addons-payment-v2__addon-item">{cost}</div>
      </div>);

  };

  // Captions get an extra layer of grouping: each `type` (e.g. "Burn-in",
  // "SRT") should appear once as a sub-label, with all caption items of
  // that type listed underneath.
  const renderCaptionsGroups = () => {
    const groups = addons.reduce((acc, addon) => {
      const key = addon.type || '';
      if (!acc[key]) {acc[key] = [];}
      acc[key].push(addon);
      return acc;
    }, {});

    return Object.entries(groups).map(([type, items]) =>
    <div key={type}>
        {type &&
      <Text heading5 className="addons-payment-v2__order-summary--content__subtitle">
            {type}
          </Text>}

        {items.map(renderAddonRow)}
      </div>
    );
  };

  if (_isEmpty(addons)) {return null;}

  return (
    <div>
      <Text heading5>{getAddonTitleByType()}</Text>
      {addonType === 'CAPTIONS' ?
      renderCaptionsGroups() :
      addons.map(renderAddonRow)}
    </div>);

}

export default AddonViewV2;